import { MutationTree } from "vuex";
import { TerminalState, Terminal } from "./model";

const mutations: MutationTree<TerminalState> = {
  setTerminals(state, terminals: Terminal[]) {
    state.terminals = terminals
  },
  addTerminal(state, terminal: Terminal) {
    state.terminals.push(terminal)
  },
  updateTerminal(state, terminal: Terminal) {
    const index = state.terminals.findIndex(c => c.id === terminal.id);
    if(index !== -1) {
      state.terminals.splice(index, 1, terminal);
    }
  },
  deleteTerminal(state, id: string) {
    state.terminals = state.terminals.filter(terminal => terminal.id !== id)
  }
}

export default mutations;
